<template>
  <div class="contact-page">
    <PageHeader title="常见问题" subtitle="以下是客户常见的一些问题，希望能够帮助到您" currentText="联系我们" />

    <div class="page-container">

      <!-- 常见问题 -->
      <div class="faq-section">
        <h2 class="section-title text-center">常见问题</h2>
        <p class="section-desc text-center">以下是客户常见的一些问题，希望能够帮助到您</p>

        <el-collapse>
          <el-collapse-item :title="item.title" :name="item.id" v-for="item in faqs" :key="item.id">
            <div v-html="item.content || ''"></div>
          </el-collapse-item>
        </el-collapse>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted, watch } from 'vue';
import { getFaqs } from '@/api/faq';
import PageHeader from '@/components/PageHeader.vue';
import ContactForm from '@/components/ContactForm.vue';

export default {
  name: 'Faq',
  components: {
    PageHeader
  },
  setup() {
    const loading = ref(false);
    const faqs = ref({})

    
    const fetchRelatedNews = async () => {
      loading.value = true;
      try {
        const res = await getFaqs({ pageNum: 0, pageSize: 999 }, {});
        if (res.data ) {
          faqs.value = res.data?.content;
        }
      } catch (error) {
        console.error('获取相关常见问题失败:', error);
      } finally {
        loading.value = false;
      }
    };

    onMounted(() => {
      fetchRelatedNews();
    });

    return {
      faqs,
      loading
    };
  }
}
</script>

<style lang="scss" scoped>
.contact-page {
  padding-bottom: 60px;

  .contact-banner {
    height: 300px;
    background-size: cover;
    background-position: center;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 60px;

    .overlay {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.5);
    }

    .banner-content {
      position: relative;
      z-index: 2;
      text-align: center;
      color: #fff;

      h2 {
        font-size: 36px;
        font-weight: 700;
        margin-bottom: 15px;
        text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
      }

      p {
        font-size: 18px;
        max-width: 600px;
        margin: 0 auto;
        opacity: 0.9;
      }
    }
  }

  .contact-content {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 50px;
    margin-bottom: 60px;

    @media (max-width: 992px) {
      grid-template-columns: 1fr;
    }

    .contact-info {
      .section-title {
        margin-bottom: 30px;
      }

      .info-list {
        margin-bottom: 40px;

        .info-item {
          display: flex;
          align-items: flex-start;
          margin-bottom: 25px;

          i {
            font-size: 24px;
            color: #409EFF;
            margin-right: 15px;
            margin-top: 5px;
          }

          .info-text {
            h3 {
              font-size: 16px;
              font-weight: 600;
              color: #333;
              margin-bottom: 5px;
            }

            p {
              font-size: 15px;
              color: #666;
              margin: 0;
            }
          }
        }
      }

      .social-links {
        margin-bottom: 40px;

        h3 {
          font-size: 18px;
          font-weight: 600;
          margin-bottom: 20px;
          color: #333;
        }

        .social-icons {
          display: flex;
          gap: 15px;

          .social-icon {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 44px;
            height: 44px;
            border-radius: 50%;
            background-color: #f5f7fa;
            color: #409EFF;
            text-decoration: none;
            transition: all 0.3s ease;

            i {
              font-size: 20px;
            }

            &:hover {
              background-color: #409EFF;
              color: #fff;
              transform: translateY(-3px);
            }
          }
        }
      }

      .company-photos {
        h3 {
          font-size: 18px;
          font-weight: 600;
          margin-bottom: 20px;
          color: #333;
        }

        .photo-grid {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 15px;

          .photo-item {
            border-radius: 8px;
            overflow: hidden;
            height: 140px;

            img {
              width: 100%;
              height: 100%;
              object-fit: cover;
              transition: transform 0.3s ease;

              &:hover {
                transform: scale(1.05);
              }
            }
          }
        }
      }
    }

    .contact-form-container {
      .section-title {
        margin-bottom: 15px;
      }

      .form-desc {
        font-size: 15px;
        color: #666;
        margin-bottom: 30px;
      }
    }
  }

  .faq-section {
    .section-title {
      margin-bottom: 15px;

      &.text-center {
        text-align: center;
      }
    }

    .section-desc {
      font-size: 15px;
      color: #666;
      margin-bottom: 30px;
      max-width: 700px;
      margin-left: auto;
      margin-right: auto;

      &.text-center {
        text-align: center;
      }
    }
  }
}

.section-title {
  font-size: 24px;
  font-weight: 600;
  color: #333;
  margin-bottom: 20px;
  position: relative;
  padding-bottom: 10px;

  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 40px;
    height: 3px;
    background-color: #409EFF;
  }

  &.text-center {
    &::after {
      left: 50%;
      transform: translateX(-50%);
    }
  }
}

.page-container {
  max-width: 1200px;
  padding: 0 15px;
  margin: 0 auto;
}
</style>